import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ChildrenRequirementDetailsContainer, CustomButton, icon, SidePanel, SidePanelContent } from "../..";
import styles from "./ChildrenRequirementDetailsSidePanel.module.css";
import { translate } from "../../../providers";
import { useApi } from "../../../hooks";
import { ParagraphOutService } from "../../../../api";

const ChildrenRequirementDetailsSidePanel = ({
	deliverableName,
	onClose,
	childrenRequirement,
	parentReqId,
	isPhaseLocked = false,
}) => {
	const { call: getAllCategoriesForParagraphOut } = useApi(ParagraphOutService.getAllCategoriesForParagraphOut);
	const { call: updateCategoriesForParagraphOut } = useApi(ParagraphOutService.updateCategoriesForParagraphOut);
	const projectId = useSelector(({ context }) => context.project?.id);
	const [updatedChildrenRequirement, setUpdatedChildrenRequirement] = useState(childrenRequirement);
	const [isEditing, setIsEditing] = useState(false);
	const [toUpdate, setToUpdate] = useState({});
	useEffect(() => {
		setUpdatedChildrenRequirement(childrenRequirement);
	}, [childrenRequirement]);
	const getAttributes = useCallback(() => {
		getAllCategoriesForParagraphOut(
			{
				projectId,
				paragraphOutId: childrenRequirement.id,
			},
			{ search: "setup/_setup_THEMES" }
		)
			.then((data) => {
				setUpdatedChildrenRequirement((prevState) => ({
					...prevState,
					themes: data,
				}));
			})
			.catch(console.error)
			.finally(() => {
				getAllCategoriesForParagraphOut(
					{
						projectId,
						paragraphOutId: childrenRequirement.id,
					},
					{ search: "setup/_setup_PHASE" }
				)
					.then((data) => {
						setUpdatedChildrenRequirement((prevState) => ({
							...prevState,
							phaseValidation: data,
						}));
					})
					.catch(console.error);
			})
			.finally(() => {
				getAllCategoriesForParagraphOut(
					{
						projectId,
						paragraphOutId: childrenRequirement.id,
					},
					{ search: "setup/_setup_LOCALISATION" }
				)
					.then((data) => {
						setUpdatedChildrenRequirement((prevState) => ({
							...prevState,
							locations: data,
						}));
					})
					.catch(console.error);
			})
			.finally(() => {
				getAllCategoriesForParagraphOut(
					{
						projectId,
						paragraphOutId: childrenRequirement.id,
					},
					{ search: "setup/_setup_METHOD" }
				)
					.then((data) => {
						setUpdatedChildrenRequirement((prevState) => ({
							...prevState,
							methodValidation: data,
						}));
					})
					.catch(console.error);
			});
	}, [getAllCategoriesForParagraphOut, childrenRequirement, projectId]);
	useEffect(() => {
		if (childrenRequirement && parentReqId && projectId) {
			getAttributes();
		}
	}, [getAttributes, childrenRequirement, parentReqId, projectId]);
	const handleClose = () => {
		setIsEditing(false);
		onClose();
	};
	const handleInitEdit = () => {
		setIsEditing(true);
	};
	const handleCancelEdit = () => {
		setIsEditing(false);
		setToUpdate({});
	};

	const handleSaveEdit = () => {
		let addThematic = [];
		let deleteThematic = [];
		Object.keys(toUpdate)?.forEach((key) => {
			addThematic = [...addThematic, ...toUpdate[key].toAdd];
			deleteThematic = [...deleteThematic, ...toUpdate[key].toDelete];
		});
		updateCategoriesForParagraphOut(
			{ projectId, paragraphOutId: childrenRequirement.id },
			{ addThematic, deleteThematic }
		)
			.then(() => {
				getAttributes();
				setIsEditing(false);
			})
			.catch(console.error);
	};
	const handleUpdatedChildrenRequirement = (identifier, toAdd, toDelete) => {
		setToUpdate((prev) => ({ ...prev, [identifier]: { toAdd, toDelete } }));
	};
	const getReqIdStringValue = () => {
		let newId = `${updatedChildrenRequirement?.id}-${updatedChildrenRequirement?.informationId}`;
		if (updatedChildrenRequirement?.informationRef) {
			newId = `${newId}(${updatedChildrenRequirement?.informationRef})`;
		}
		return newId;
	};
	return (
		<SidePanel open={!!childrenRequirement} size={65} onClose={handleClose}>
			<SidePanelContent
				headerClassName={styles.header}
				secondaryActions={
					(isEditing && (
						<span className={styles.secondaryActions}>
							<CustomButton color="secondary" variant="outlined" onClick={handleCancelEdit}>
								{translate("common:btn.cancel")}
							</CustomButton>
							<CustomButton
								color="primary"
								startIcon={icon.faSave}
								variant="contained"
								onClick={handleSaveEdit}
							>
								{translate("common:btn.save")}
							</CustomButton>
						</span>
					)) || (
						<CustomButton
							color="primary"
							disabled={isPhaseLocked}
							startIcon={icon.faPenToSquare}
							variant="contained"
							onClick={handleInitEdit}
						>
							{translate("common:btn.edit")}
						</CustomButton>
					)
				}
				title={getReqIdStringValue()}
				onClose={handleClose}
			>
				<ChildrenRequirementDetailsContainer
					deliverableName={deliverableName}
					isEditing={isEditing}
					isPhaseLocked={isPhaseLocked}
					updatedChildrenRequirement={updatedChildrenRequirement}
					onUpdateChildrenRequirement={handleUpdatedChildrenRequirement}
				/>
			</SidePanelContent>
		</SidePanel>
	);
};

export default ChildrenRequirementDetailsSidePanel;
